export enum URLS_API {
  CHECK_LOG_IN = '/bff-vle/checkLogin',
  CONFIG_SYSTEM = '/bff-vle/system/configs',
  LOGOUT = '/bff-vle/logout',
  RESEND_EMAIL = '/bff-vle/users/welcomeEmail',
}
